import { Box, Button, Typography } from '@mui/material'
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import useAxios from 'packages/novous_web/src/api/useAxios';
import { useAuth } from 'packages/novous_web/src/authContext/useAuth';
import React, { useEffect, useMemo, useState } from 'react'

interface PauseReportData {
    reportName: string;
    date_time: string;
    fleet_id: string;
    parent_id: string;
    vehicle_group: string;
    nextReportDue: string;
    timeZone: string;
    reportStatus: number;
    frequency: string;
    hourlyFrequency: number;
    weekDay: string;
    scheduledTime: string;
    startDate: string;
    endDate: string;
    reportConsideredFrom: string;
    reportFormat: string;
    emailMessage: string;
    emailID: string;
    editedTime: string;
    createdTime: string;
    completionStatus: string;
    emailSendStatus: number
}

const DeleteAccount = ({
    deleteOpen,
    setDeleteOpen,
    selectAccount,
    onDeleteSuccess
}: {
    deleteOpen: boolean,
    setDeleteOpen: React.Dispatch<React.SetStateAction<boolean>>,
    selectAccount: any,
    onDeleteSuccess: () => void
}) => {

    const { user } = useAuth();
    const [pauseReports, setPauseReport] = useState<PauseReportData[]>([]);

    const {
        data: scheduleReportDelete,
        error: scheduleReportDeleteError,
        loading: scheduleReportDeleteLoading,
        fetchData: scheduleReportDeleteData,
    } = useAxios<any>(`${API_ENDPOINTS.users.USER_ACTIVE_DELETE}`, "POST");

    const handelDeleteReport = async (e: React.FormEvent) => {
        e.preventDefault();
        const payload: any = {
            userId: selectAccount.id
        };

        try {
            await scheduleReportDeleteData(payload);
            console.log('Report saved successfully');
            onDeleteSuccess();
            setDeleteOpen(!deleteOpen);
        } catch (error) {
            console.error('Error saving report:', error);
        }
    };

    return (
        <div className='w-full h-full fixed left-0 right-0 mx-auto top-0 flex z-[999]'>
            <div className='fixed w-full h-full bg-black opacity-50 top-0 left-0 z-[999]'></div>
            <Box className='absolute left-0 right-0 mx-auto z-[1000] top-1/2 transform -translate-y-1/2 rounded-xl lg:w-full md:w-full w-[90%] max-w-[480px] p-4' sx={{
                bgcolor: 'background.paper'
            }}>
                <Typography variant="h4" fontSize="24px" fontWeight={600} lineHeight='36px' marginBottom='14px'>
                    Delete Account
                </Typography>
                <Typography variant="body1" fontSize="14px" fontWeight={100} lineHeight='26px' marginBottom='14px'>
                    {`Are you sure you want to permanently delete ${selectAccount?.username}’s account? This action cannot be undone`}
                </Typography>
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    gap: 4,
                    mt: 4
                }}>
                    <Button
                        variant="outlined"
                        onClick={() => setDeleteOpen(!deleteOpen)}
                        sx={{
                            px: 2,
                            py: 1,
                            borderRadius: '8px',
                            borderColor: '#5547DD',
                            color: '#5547DD',
                            textTransform: 'none',
                            fontSize: '14px',
                            fontWeight: 600,
                            '&:hover': {
                                borderColor: '#5547DD',
                                backgroundColor: 'rgba(0, 0, 0, 0.04)'
                            }
                        }}
                    >
                        Cancel
                    </Button>
                    <Box sx={{
                        display: 'flex', justifyContent: 'space-between',
                        gap: 2
                    }}>
                        <Button
                            variant="contained"
                            onClick={handelDeleteReport}
                            sx={{
                                px: 2,
                                py: 1,
                                borderRadius: '8px',
                                backgroundColor: '#C83333',
                                color: '#fff',
                                textTransform: 'none',
                                fontSize: '14px',
                                fontWeight: 600,
                                '&:hover': {
                                    backgroundColor: '#C83333'
                                }
                            }}
                        >
                            Delete
                        </Button>
                    </Box>
                </Box>
            </Box>
        </div>
    )
}

export default DeleteAccount